import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { BooleanReviewedCareElement } from "@/Flowsheets/Models/CareElements/BooleanReviewedCareElement";
import { CareComponent } from "@/Flowsheets/Models/CareElements/CareComponent";
import CareComponentNotes from "./CareComponentParts/CareComponentNotes";
import CareElementDateReviewedCheckbox from "./CareComponentParts/DateReviewedCareElementComponents/CareElementDateReviewedCheckbox";
import { ReviewedCareElementContainer } from "./CareComponentParts/DateReviewedCareElementComponents/ReviewedDateContainer";
import { ICareComponentProps } from "./Types";

import styles from "./CounselingAndEducationCareComponent.module.scss";

interface BooleanCareComponent extends CareComponent {
    CareElements: BooleanReviewedCareElement[];
}

function CounselingAndEducationCareComponent({
    isEditable = false,
    state,
    mutateState
}: Readonly<ICareComponentProps<BooleanCareComponent>>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={styles.counselingCareComponent}>
            {/* Header Row */}
            <div className={styles.careComponentSubTitle}>
                {getText("Flowsheets_CounselingAndEducationCareComponentLabel_MotivationalCounsellingAndEducation")}
            </div>
            <div className={styles.careComponentDirectives}>
                {getText("Flowsheets_CounselingAndEducationCareComponentLabel_Instruction")}
            </div>
            <div className={styles.counselingCareComponentHeader}>
                {getText("Flowsheets_TopicLabel")}
            </div>
            {/* Data Rows */}
            <ReviewedCareElementContainer>
                {state.CareElements.map(careElement => (
                    <CareElementDateReviewedCheckbox
                        key={`${careElement.Name}-${state.Id}`}
                        label={getText(`Flowsheets_CounselingAndEducationCareComponentLabel_${careElement.Name}`)}
                        isEditable={isEditable}
                        element={careElement}
                        onChange={(element: BooleanReviewedCareElement) => mutateState(state => {
                            state.CareElements = [...state.CareElements];
                            const index = state.CareElements.findIndex(p => p.Name === element.Name);
                            if (index !== -1) {
                                state.CareElements[index] = element;
                            }
                        })}
                    />
                ))}
            </ReviewedCareElementContainer>
            <CareComponentNotes
                id={`counselingAndEducationNotes-${state.Id}`}
                dataCy="CounselingAndEducationNotes"
                value={state.Note}
                isEditable={isEditable}
                onTextChange={newValue => mutateState(s => s.Note = newValue)}
            />
        </div>
    );
}

export { CounselingAndEducationCareComponent };
